import React from "react";
import generateAndDownloadReceipt from "./pdfgen";
import accounting from "accounting";

function History({ billHistory, email }) {
  return (
    <div className="flex max-w-full flex-col p-5 gap-4 rounded-lg text-black text-base">
      <h6 className="font-semibold text-black text-xl 2xl:text-[1.1vw] mb-2">
        Billing History
      </h6>
      <div className="w-full h-[1px] rounded-xl bg-black"></div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              {[
                "Billing Date",
                "Order ID",
                "Billing Currency",
                "Billing Amount",
                "Plan",
                "Billing Method",
                "Download Receipt",
              ].map((header, idx) => (
                <th
                  key={idx}
                  className="px-6 py-3 text-center text-sm font-medium text-gray-700 2xl:text-[1vw]">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {billHistory?.map((row, index) => (
              <tr key={index} className="text-center">
                <td className="px-6 py-3 text-slate-950 break-all">
                  {new Date(row.created_at * 1000).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </td>
                <td className="px-6 py-3 text-slate-950 break-all">
                  {row.order_id}
                </td>
                <td className="px-6 py-3 text-slate-950 break-all">
                  {row.currency}
                </td>
                <td className="px-6 py-3 text-slate-950 break-all">
                  {accounting.formatNumber(row.amount / 100)}
                </td>
                <td className="px-6 py-3 text-slate-950 break-all">
                  {row.description}
                </td>
                <td className="px-6 py-3 text-slate-950 break-all">
                  {row.method}
                </td>
                <td className="px-6 py-3">
                  <button
                    className="text-blue-600 hover:underline text-sm 2xl:text-[1vw]"
                    onClick={() => {
                      generateAndDownloadReceipt(
                        row.amount / 100,
                        row.order_id,
                        row.currency,
                        row.description,
                        row.email || email,
                        row.contact,
                        row.id,
                        row.method,
                        row.created_at
                      );
                    }}>
                    Download
                  </button>
                </td>
              </tr>
            ))}
            {billHistory?.length === 0 && (
              <tr>
                <td
                  colSpan="7"
                  className="px-6 py-3 text-center text-gray-500 italic">
                  No billing records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default History;
